import { useEffect } from "react";
import { usePublicConfig } from "@/api/queries/config";
import { initCookieConsent } from "@/lib/cookie-consent";

export function CookieConsent() {
	const { data: config } = usePublicConfig();

	useEffect(() => {
		const gtmId = config?.gtmId ?? null;
		initCookieConsent(gtmId);
	}, [config?.gtmId]);

	return null; // vanilla-cookieconsent rendert selbst ins DOM
}
